import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyohizeiKanriListGetReq,
  TSyohizeiKanriListGetRes,
} from "./TSyohizeiKanri"

/**
 * 消費税管理マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class SyohizeiKanriService
 * @extends {ConnectApi}
 */
export default class SyohizeiKanriService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyohizeiKanriListGetReq} params
   * @memberof SyohizeiKanriService
   */
  getList = async (params?: TSyohizeiKanriListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyohizeiKanriListGetRes[]>> =
        await this.getInner(`/master/syohizeiKanri`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }
}
